// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","464":"da4c3577","523":"1ffe7e97","524":"cfe0d5ed","573":"a82f069e","933":"e8092cf1"}[chunkId] + ".chunk.js";
};